import React from 'react';
import './BuyNode.css';

const NodeBadge = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="4" r="2.2" />
    <circle cx="4.5" cy="17" r="2.2" />
    <circle cx="19.5" cy="17" r="2.2" />
    <circle cx="12" cy="12" r="2.2" />
    <path d="M12 6.2v3.6M10.3 13.4l-4 2.2M13.7 13.4l4 2.2" />
  </svg>
);

const DexIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 8.5h13l-3.2-3.3M20 15.5H7l3.2 3.3" />
  </svg>
);

const BuyNode = () => {
  return (
    <div className="container bn-wrap">
      <header className="page-hero">
        <div className="page-hero-text">
          <span className="page-hero-eyebrow">Smartcore Node</span>
          <h1 className="page-hero-title">Node & DEX</h1>
          <p className="page-hero-sub">Own a fractional node and trade your tokens on Smartcore.</p>
        </div>
      </header>

      <div className="bn-announce">
        {/* Fractional Node — LIVE */}
        <div className="bn-card" style={{ '--acc': '#34f5c5' }}>
          <span className="bn-card-badge live">● LIVE NOW</span>
          <div className="bn-card-gem"><NodeBadge /></div>
          <h2 className="bn-card-title">Smartcore Fractional Node</h2>
          <p className="bn-card-text">
            Smartcore Fractional Node is <b>live now</b>. Own a fraction of the
            network and start participating.
          </p>
          <a
            href="https://node.smartcore.live/"
            target="_blank"
            rel="noopener noreferrer"
            className="bn-card-btn"
          >
            Visit Node Portal →
          </a>
          <span className="bn-card-url">node.smartcore.live</span>
        </div>

        {/* DEX — Day 180 */}
        <div className="bn-card" style={{ '--acc': '#fbbf24' }}>
          <span className="bn-card-badge soon">◷ FROM DAY 180</span>
          <div className="bn-card-gem"><DexIcon /></div>
          <h2 className="bn-card-title">Smartcore DEX</h2>
          <p className="bn-card-text">
            On the <b>180th day of mining</b>, Smartcore DEX goes live — sell your
            <b> SCN</b> and <b>CORE</b> tokens directly on the exchange.
          </p>
          <a
            href="https://dex.smartcore.live/"
            target="_blank"
            rel="noopener noreferrer"
            className="bn-card-btn"
          >
            Visit DEX →
          </a>
          <span className="bn-card-url">dex.smartcore.live</span>
        </div>
      </div>
    </div>
  );
};

export default BuyNode;
